const SISENSE_BLACK = '#000000';
const SISENSE_WHITE = '#FFFFFF';

export default function SisenseLogo({ isDarkBackground = false }: { isDarkBackground: boolean }) {
  const fillColor = isDarkBackground ? SISENSE_WHITE : SISENSE_BLACK;
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 500 504"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M365.111 69.5654C350.571 69.5654 338.747 81.3237 338.747 95.7826C338.747 110.241 350.571 122 365.111 122C379.651 122 391.476 110.241 391.476 95.7826C391.476 81.3237 379.651 69.5654 365.111 69.5654Z"
        fill={fillColor}
      />
      <path
        d="M135.365 147.679C120.824 147.679 109 159.437 109 173.896C109 188.355 120.824 200.113 135.365 200.113C149.905 200.113 161.715 188.355 161.715 173.896C161.715 159.437 149.891 147.679 135.365 147.679Z"
        fill={fillColor}
      />
      <path
        d="M135.365 225.789C120.824 225.789 109 237.547 109 252.006C109 266.465 120.824 278.21 135.365 278.21C149.905 278.21 161.715 266.451 161.715 252.006C161.715 237.561 149.891 225.789 135.365 225.789Z"
        fill={fillColor}
      />
      <path
        d="M364.401 225.789C349.861 225.789 338.037 237.547 338.037 252.006C338.037 266.465 349.861 278.21 364.401 278.21C378.941 278.21 390.766 266.451 390.766 252.006C390.766 237.561 378.941 225.789 364.401 225.789Z"
        fill={fillColor}
      />
      <path
        d="M365.111 303.899C350.571 303.899 338.747 315.658 338.747 330.117C338.747 344.575 350.571 356.334 365.111 356.334C379.651 356.334 391.476 344.575 391.476 330.117C391.476 315.658 379.651 303.899 365.111 303.899Z"
        fill={fillColor}
      />
      <path
        d="M135.365 382.013C120.824 382.013 109 393.771 109 408.23C109 422.689 120.824 434.447 135.365 434.447C149.905 434.447 161.715 422.689 161.715 408.23C161.715 393.771 149.891 382.013 135.365 382.013Z"
        fill={fillColor}
      />
      <path
        d="M289.516 142.11C271.898 142.11 257.567 156.362 257.567 173.895C257.567 191.429 271.898 205.666 289.516 205.666C307.135 205.666 321.466 191.415 321.466 173.895C321.466 156.375 307.135 142.11 289.516 142.11Z"
        fill={fillColor}
      />
      <path
        d="M210.96 142.11C193.342 142.11 179.01 156.362 179.01 173.895C179.01 191.429 193.342 205.666 210.96 205.666C228.578 205.666 242.909 191.415 242.909 173.895C242.909 156.375 228.578 142.11 210.96 142.11Z"
        fill={fillColor}
      />
      <path
        d="M289.516 220.224C271.898 220.224 257.567 234.475 257.567 252.008C257.567 269.542 271.898 283.779 289.516 283.779C307.135 283.779 321.466 269.528 321.466 252.008C321.466 234.489 307.135 220.224 289.516 220.224Z"
        fill={fillColor}
      />
      <path
        d="M210.96 220.224C193.342 220.224 179.01 234.475 179.01 252.008C179.01 269.542 193.342 283.779 210.96 283.779C228.578 283.779 242.909 269.528 242.909 252.008C242.909 234.489 228.578 220.224 210.96 220.224Z"
        fill={fillColor}
      />
      <path
        d="M289.516 298.334C271.898 298.334 257.567 312.585 257.567 330.105C257.567 347.624 271.898 361.889 289.516 361.889C307.135 361.889 321.466 347.638 321.466 330.105C321.466 312.571 307.135 298.334 289.516 298.334Z"
        fill={fillColor}
      />
      <path
        d="M210.96 298.334C193.342 298.334 179.01 312.585 179.01 330.105C179.01 347.624 193.342 361.889 210.96 361.889C228.578 361.889 242.909 347.638 242.909 330.105C242.909 312.571 228.578 298.334 210.96 298.334Z"
        fill={fillColor}
      />
      <path
        d="M289.516 64C271.898 64 257.567 78.2512 257.567 95.7847C257.567 113.318 271.898 127.555 289.516 127.555C307.135 127.555 321.466 113.304 321.466 95.7847C321.466 78.265 307.135 64 289.516 64Z"
        fill={fillColor}
      />
      <path
        d="M210.96 64C193.342 64 179.01 78.2512 179.01 95.7847C179.01 113.318 193.342 127.555 210.96 127.555C228.578 127.555 242.909 113.304 242.909 95.7847C242.909 78.265 228.578 64 210.96 64Z"
        fill={fillColor}
      />
      <path
        d="M289.516 376.442C271.898 376.442 257.567 390.694 257.567 408.213C257.567 425.733 271.898 439.998 289.516 439.998C307.135 439.998 321.466 425.747 321.466 408.213C321.466 390.68 307.135 376.442 289.516 376.442Z"
        fill={fillColor}
      />
      <path
        d="M210.96 376.442C193.342 376.442 179.01 390.694 179.01 408.213C179.01 425.733 193.342 439.998 210.96 439.998C228.578 439.998 242.909 425.747 242.909 408.213C242.909 390.68 228.578 376.442 210.96 376.442Z"
        fill={fillColor}
      />
    </svg>
  );
}
